import { createBrowserClient } from "@supabase/ssr"
import {
  NEXT_PUBLIC_SUPABASE_URL,
  NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY,
  NEXT_PUBLIC_TEST_MODE,
} from "@/lib/env"
import type { Database } from "@aient/types/database"

/**
 * Singleton browser client to avoid multiple GoTrueClient instances sharing the
 * same storage key (see Supabase warning). Safe to call repeatedly.
 */
let browserClient: ReturnType<typeof createBrowserClient<Database>> | null = null

async function runWithoutCrossContextLock<Result>(
  _name: string,
  _acquireTimeout: number,
  fn: () => Promise<Result>,
): Promise<Result> {
  return fn()
}

export function createClient(): ReturnType<typeof createBrowserClient<Database>> {
  if (!browserClient) {
    browserClient = createBrowserClient<Database>(
      NEXT_PUBLIC_SUPABASE_URL!,
      NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!,
      {
        auth: {
          flowType: "pkce",
          ...(NEXT_PUBLIC_TEST_MODE
            ? {
                autoRefreshToken: false,
                lock: runWithoutCrossContextLock,
              }
            : {}),
        },
      },
    )
  }
  return browserClient!
}
